/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbCiClassAttribute {
    getFixupPrototypeFunction() { return ServiceNowCmdbCiClassAttribute.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbCiClassAttribute>): ServiceNowCmdbCiClassAttribute {
        let obj = Object.assign(new ServiceNowCmdbCiClassAttribute(), model);
        ServiceNowCmdbCiClassAttribute.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbCiClassAttribute>): ServiceNowCmdbCiClassAttribute {
        if (!model) return null;
        return ServiceNowCmdbCiClassAttribute.newInstance(<ServiceNowCmdbCiClassAttribute> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbCiClassAttribute) {
        if (!obj) return;

        models.ServiceNowCmdbCiClassAttribute.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbCiClassAttribute): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbCiClassAttribute.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Cmdb Ci Class
     */
    name: string;

    /**
     * Display Name of the Cmdb Ci Class
     */
    label: string;

    /**
     * Mandatory attribute Flag
     */
    mandatory: boolean;

}
